import {Separator} from 'platform/components';
import {Box, CSSDimension, Integer, Show, ValueByDevice, VStack} from 'platform/foundation';

import {forwardRef} from 'react';

import {ArticleFolderTree} from '@dms/shared';
import {DataGridTreeFolderHandle} from '@dms/shared-aftersales';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface ExternalFilterWithFolderTreeProps extends RequiredTestIdProps {
  externalFilterId: string;
  width?: CSSDimension | Integer | ValueByDevice<CSSDimension | Integer>;
}

export const ExternalFilterWithFolderTree = forwardRef<
  DataGridTreeFolderHandle,
  ExternalFilterWithFolderTreeProps
>((props, ref) => (
  <Box width={props.width} data-testid={props['data-testid']}>
    <VStack height="100%">
      <Box flexGrow={1}>
        <div id={props.externalFilterId} />
      </Box>
      <Show when={ref}>
        <Separator />
        <ArticleFolderTree ref={ref} data-testid={suffixTestId('articleFolderTree', props)} />
      </Show>
    </VStack>
  </Box>
));
